import Airbnb from "@assets/svg/AirbnbLogo.svg?react";
import AutomationChat from "@assets/svg/Automation.chat.svg?react";
import AutomationChatSquareCall from "@assets/svg/Automation.ChatSquareCall.svg?react";
import AutomationEdit from "@assets/svg/Automation.edit.svg?react";
import AutomationInboxOut from "@assets/svg/Automation.InboxOut.svg?react";
import WhatsApp from "@assets/svg/Automation.whatsApp.svg?react";
import BookingIcon from "@assets/svg/BookingActive.svg?react";
import Gathren from "@assets/svg/GatherInSoon.svg?react";
import CustomTable from "@Common/CustomTable";
import { AutomationCentre, LoadingWrapper, Toggle } from "@components";
import useBreakPoinst from "@hooks/useBreakPoinst";
//@ts-nocheck:
import { Box, Button, Grid, Typography } from "@mui/material";
import { useAutomation } from "@services";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomNoRowsOverlay } from "../../../components/CategoryManagement/CustomNoRowsOverlay";
import { SectionTableWrapper } from "../../../components/OwnerManagement/SectionTable/styles";
import BookingConfirmation from "./BookingConfirmation";
import Edit from "./Edit";
import MessegingCard from "./MessegingCard";

interface Automation {
  id: number;
  name: string;
  sentTime: string;
  modifiedAt: string;
  isActive: boolean;
  isOnboardingComplete: boolean;
  onboardingText: any;
}
const AutomationStep2 = () => {
  const { isPhone } = useBreakPoinst();
  const [NumberOfPages, setNumberOfPages] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [selectedAutomation, setSelectedAutomation] =
    useState<Automation | null>(null);

  const [perPage, onPerpageChange] = useState("20");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openAfterOnboarding, setOpenAfterOnboarding] = useState(false);
  const [idSelectedRecord, setIdSelectedRecord] = useState<number>();
  const [templetNameState, setTempletNameState] = useState<string>();
  const [editVisable, setEditVisable] = useState(false);

  const toggleEditVisable = () => {
    setEditVisable(!editVisable);
  };

  const {
    t,
    i18n: { language },
  } = useTranslation();
  const isRtl = language == "ar";
  /*----------------------
  Queries 
-----------------------*/
  const { GetAllAutomationsQuery, updateActivityMutate } = useAutomation();
  const { data, isLoading, refetch } = GetAllAutomationsQuery({
    pageNumber: activePage.toString(),
    pageSize: perPage,
  });
  const { mutate } = updateActivityMutate({
    onSuccess: () => refetch(),
  });

  const activeMasseges = data?.result.activeMasseges;
  const sentMasseges = data?.result.sentMasseges;
  const activatedSendingChannels = data?.result.activatedSendingChannels;
  const automationList = data?.result?.automations;
  const totalRecords = data?.totalRecords;
  const automationLastElement = automationList?.[automationList?.length - 1];

  /*----------------------
  Table Columns 
-----------------------*/
  const columns = [
    {
      field: "templateName",
      headerName: t("Automation.TemplateName"),
      flex: 1,
      renderCell: (params: any) => {
        const [isChecked, setIsChecked] = useState(params?.row?.isActive);
        return (
          <p
            onClick={() => {
              setTimeout(() => {
                setSelectedAutomation(params?.row);
                toggleEditVisable();
              }, 200);
            }}
            className="columnsContent"
            style={{
              textAlign: `${language === "ar" ? "right" : "left"}`,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <span
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Toggle
                disabled={params?.row?.isComingSoon}
                onChange={() => {
                  setIsChecked((prev: any) => !prev);
                  mutate({ id: params?.row?.id });
                }}
                checked={isChecked}
              />
            </span>

            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (params?.row?.isComingSoon) {
                  return;
                }
                setTimeout(() => {
                  setSelectedAutomation(params?.row);
                  toggleEditVisable();
                }, 200);
              }}
            >
               {language === "ar" ? params?.row?.onboardingText?.mainInfo?.titleAr : params?.row?.onboardingText?.mainInfo?.titleEn}
            </span>
            <span
              style={{
                display: params?.row?.isComingSoon ? "flex" : "none",
                width: "47px",
                height: "18px",
                background: "#5B3FFF",
                borderRadius: "70px",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "12px",
                fontWeight: "400",
                color: "#FFFFFF",
                opacity: "0.6",
              }}
            >
              {t("Automation.soon")}
            </span>
          </p>
        );
      },
    },
    {
      field: "sendTime",
      headerName: t("Automation.SendingTime"),
      flex: 1,
      renderCell: (params: any) => (
        <p
          className="columnsContent"
          style={{ textAlign: `${language === "ar" ? "right" : "left"}` }}
        >
          {language === "ar" ? params.row.sentTimeAr : params.row.sentTimeEn}
        </p>
      ),
    },
    {
      field: "sendChannels",
      headerName: t("Automation.SendingChannels"),
      flex: 1,
      renderCell: (params: any) => (
        <div
          className="columnsContent"
          style={{ textAlign: `${language === "ar" ? "right" : "left"}` }}
        >
          {params.row.senderChannels.map((item: any) => (
            <div key={item.id}>
              <span style={{ opacity: !item.isActive ? 0.4 : 1 }}>
                {item.name.includes("whatsapp") && <WhatsApp />}
              </span>
              <span style={{ opacity: !item.isActive ? 0.4 : 1 }}>
                {item.name.includes("airbnb") && <Airbnb />}
              </span>
              <span style={{ opacity: !item.isActive ? 0.4 : 1 }}>
                {item.name.includes("booking") && <BookingIcon />}
              </span>
              <span style={{ opacity: !item.isActive ? 0.4 : 1 }}>
                {item.name.includes("gathren") && <Gathren />}
              </span>
            </div>
          ))}
        </div>
      ),
    },
    {
      field: "lastEdit",
      headerName: t("Automation.LastModification"),
      flex: 1,
      renderCell: (params: any) => (
        <p
          className="columnsContent"
          style={{ textAlign: `${language === "ar" ? "right" : "left"}` }}
        >
          {params.row.lastEdit}
        </p>
      ),
    },
    {
      field: "Actions",
      headerName: "",
      flex: 1,
      renderCell: (params: any) => {
        const isLastRow = params?.row?.id === automationLastElement?.id;

        return (
          <p
            className="columnsActions"
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "15px",
            }}
          >
            <span
              onClick={() => {
                if (params?.row?.isComingSoon) {
                  return;
                }
                setTimeout(() => {
                  setSelectedAutomation(params?.row);
                  toggleEditVisable();
                }, 200);
              }}
            >
              <AutomationEdit
                style={{ cursor: "pointer", width: "20px", height: "20px" }}
              />
            </span>
            <span
              style={{
                display: !editVisable
                  ? "none"
                  : selectedAutomation?.id === params?.row?.id
                    ? "block"
                    : "none",
                cursor: "pointer",
                position: "absolute",
                transform: isRtl
                  ? `translate(-30%, ${isLastRow ? "-100%" : "70%"})`
                  : `translate(30%, ${isLastRow ? "-100%" : "70%"})`,
              }}
              onClick={() => {
                if (params?.row?.isComingSoon) {
                  return;
                }
                if (!params?.row?.isOnboardingComplete) {
                  setOpenConfirmation(true);
                } else {
                  setOpenAfterOnboarding(true);
                }
                const automation = automationList?.find(
                  (item: any) => item?.id === params?.row?.id
                );

                setIdSelectedRecord(automation.id);
                setTempletNameState(automation.name);
              }}
            >
              <Edit />
            </span>
          </p>
        );
      },
    },
  ];
  /*----------------------
  Table Rows 
-----------------------*/
  const rows = useMemo(() => {
    return automationList?.map((item: any) => {
      let isOnboardingComplete = item?.isOnboardingComplete;
      let senderChannels = item?.senderChannels;
      let id = item.id;
      let templateName = item?.name;
      let sendTime = isRtl ? item?.sentTimeAr : item?.sentTimeEn;
      let lastEdit = new Date(item?.modifiedAt)
        .toLocaleString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");

      return {
        isOnboardingComplete,
        senderChannels,
        id,
        templateName,
        sendTime,
        lastEdit,
        isActive: item.isActive,
        isComingSoon: item?.isComingSoon,
        onboardingText: item?.onboardingText,
        sentTimeAr: item?.sentTimeAr,
        sentTimeEn: item?.sentTimeEn,
      };
    });
  }, [automationList, isRtl]);

  useEffect(() => {
    if (totalRecords) {
      setNumberOfPages(Math.ceil(totalRecords / Number(perPage)));
    }
  }, [totalRecords, perPage]);
  return (
    <div
      onClick={() => {
        setEditVisable(false);
      }}
    >
      {openAfterOnboarding && (
        <AutomationCentre
          onclose={() => {
            setSelectedAutomation(null);
            setOpenAfterOnboarding(false);
          }}
          id={idSelectedRecord}
          templetName={templetNameState}
        />
      )}
      <span style={{ display: openConfirmation ? "block" : "none" }}>
        <BookingConfirmation
          openAfterConfirmation={() => {
            setOpenAfterOnboarding(true);
          }}
          id={selectedAutomation?.id}
          refetch={refetch}
          mainInfoTitle={
            isRtl
              ? selectedAutomation?.onboardingText?.mainInfo?.titleAr
              : selectedAutomation?.onboardingText?.mainInfo?.titleEn
          }
          mainInfoDescription={
            isRtl
              ? selectedAutomation?.onboardingText?.mainInfo?.descriptionAr
              : selectedAutomation?.onboardingText?.mainInfo?.descriptionEn
          }
          generalOverviewTitle={
            isRtl
              ? selectedAutomation?.onboardingText?.generalOverview?.titleAr
              : selectedAutomation?.onboardingText?.generalOverview?.titleEn
          }
          generalOverviewDescription={
            isRtl
              ? selectedAutomation?.onboardingText?.generalOverview
                  ?.descriptionAr
              : selectedAutomation?.onboardingText?.generalOverview
                  ?.descriptionEn
          }
          benefits={
            Array.isArray(selectedAutomation?.onboardingText?.benefits)
              ? selectedAutomation?.onboardingText?.benefits.map(
                  (benefit: {
                    titleEn: string;
                    titleAr: string;
                    descriptionEn: string;
                    descriptionAr: string;
                  }) => ({
                    title: isRtl ? benefit.titleAr : benefit.titleEn,
                    description: isRtl
                      ? benefit.descriptionAr
                      : benefit.descriptionEn,
                  })
                )
              : undefined
          }
          onclose={() => {
            setOpenConfirmation(false);
            setSelectedAutomation(null);
          }}
        />
      </span>

      <LoadingWrapper loading={isLoading}>
        <SectionTableWrapper>
          <Grid container gap={"24px"}>
            <section
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  direction: isRtl ? "rtl" : "ltr",
                  height: "55px",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  sx={{
                    typography: "h6",
                    fontWeight: 700,
                    fontSize: "20px",
                    lineHeight: "24px",
                    letterSpacing: "0%",
                    textTransform: "capitalize",
                    direction: isRtl ? "rtl" : "ltr",
                    color: "#130080",
                  }}
                >
                  {t("Automation.ControlCenter")}
                </Typography>
                <Typography
                  sx={{
                    typography: "body1",
                    fontWeight: 400,
                    fontSize: isPhone ? "12px" : "16px",
                    lineHeight: "19.2px",
                    direction: isRtl ? "rtl" : "ltr",
                    color: "#ADBAC7",
                    paddingTop: "10px",
                  }}
                >
                  {t("Automation.ManageAllAutomationOperations")}
                </Typography>
              </Box>

              <Button
                style={{
                  width: isPhone ? "200px" : "350px",
                  height: "41px",
                  gap: "10px",
                  paddingBlock: "16px",
                  paddingRight: "97px",
                  paddingLeft: "97px",
                  borderRadius: "12px",
                  backgroundColor: "#5B3FFF",
                  color: "#FFFFFF",
                  fontWeight: isPhone ? 500 : 700,
                  fontSize: !isRtl ? "10px" : "14px",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                  opacity: 0,
                }}
              >
                {t("Automation.CreateNewTemplate")}
              </Button>
            </section>

            <span style={{ width: "100%" }}>
              <Box
                sx={{
                  width: "100%",
                  height: isPhone ? "auto" : "101px",
                  gap: "16px",
                  display: "flex",
                  flexDirection: isPhone ? "column" : "row",
                }}
              >
                <MessegingCard
                  activeMasseges={activeMasseges}
                  width="100%"
                  icon={<AutomationChat style={{ width: 32, height: 32 }} />}
                  message={t("Automation.EnabledMessages")}
                />
                <MessegingCard
                  sentMasseges={sentMasseges}
                  width="100%"
                  icon={
                    <AutomationInboxOut style={{ width: 32, height: 32 }} />
                  }
                  message={t("Automation.SentMessages")}
                />
                <MessegingCard
                  activatedSendingChannels={activatedSendingChannels}
                  width="100%"
                  icon={
                    <AutomationChatSquareCall
                      style={{ width: 32, height: 32 }}
                    />
                  }
                  message={t("Automation.Responses")}
                />
              </Box>
            </span>

            <Grid item xs={12}>
              <CustomTable
                showFilterBar={false}
                sx={{ display: isLoading ? "none" : "block" }}
                HeaderTheTable={t("Automation.AutomatedMessagesList")}
                totalPages={NumberOfPages}
                columns={columns}
                rows={rows || []}
                totalRecords={automationList?.length || 0}
                setActivePage={setActivePage}
                activePage={activePage}
                onPerpageChange={onPerpageChange}
                perPage={perPage}
                CustomNoRowsOverlay={CustomNoRowsOverlay}
                listPerPagesNumber={[
                  {
                    label: "20",
                    value: "20",
                  },
                  {
                    label: "50",
                    value: "50",
                  },
                  {
                    label: "100",
                    value: "100",
                  },
                ]}
              />
            </Grid>
          </Grid>
        </SectionTableWrapper>
      </LoadingWrapper>
    </div>
  );
};

export default AutomationStep2;
